export const newSolicitationSteps = [
  {
    target: '#start-item',
    content: 'Nesta página, é possível abrir diligências para correspondentes.',
    disableBeacon: true,
  },
  {
    target: '#solicitation-item',
    content: 'Preencha os dados necessários para abrir uma solicitação.',
  },
  {
    target: '#demand-item',
    content: 'Aqui você seleciona o tipo de serviço que será realizado.',
  },
  {
    target: '#specialty-item',
    content: 'Selecione aqui o tipo de especialidade da solicitação.',
  },
  {
    target: '#value-item',
    content: 'Aqui você definirá o preço da solicitação.',
  },
  {
    target: '#attachmentAndObservations-item',
    content: 'Caso necessário, anexe um documento ou deixa uma observação na solicitação.',
  },
];
